module.exports = __webpack_public_path__ + "static/rfa-home@2x-768x681-7bf7670b6dd00372a911b558ee37a5ee.png";